import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { ClockIcon } from '../../../../components/ui/Icons';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardContent 
} from '../../../../components/ui';
import dayjs from 'dayjs';

const ApprovalTimeline = ({ selectedRecord, isOverdue }) => {
  const { theme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center">
          <ClockIcon className="w-4 h-4 mr-2" />
          Request Timeline
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {selectedRecord.requestedAt && (
            <div className="flex items-center justify-between py-2">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Requested</span>
              <span className={cn("text-sm font-medium", theme.text.primary)}>
                {dayjs(selectedRecord.requestedAt).format('MMM DD, YYYY HH:mm')}
              </span>
            </div>
          )}
          {selectedRecord.dueDate && (
            <div className="flex items-center justify-between py-2">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Due Date</span>
              <span className={`text-sm font-medium ${isOverdue ? 'text-red-600' : theme.text.primary}`}>
                {dayjs(selectedRecord.dueDate).format('MMM DD, YYYY HH:mm')}
                {isOverdue && <span className="ml-1 text-red-500">(Overdue)</span>}
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ApprovalTimeline;

